module.exports = __webpack_public_path__ + "img/Logo_bianco.539e8ee2.svg";